import { render } from "./F1.vue?vue&type=template&id=3dbe5483&scoped=true"
import script from "./F1.vue?vue&type=script&lang=js"
export * from "./F1.vue?vue&type=script&lang=js"

import "./F1.vue?vue&type=style&index=0&id=3dbe5483&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbe5483"]])

export default __exports__